import { atom, selector } from "recoil";
import { createDataRequest, getAtollListRequest, updateDataRequest } from "../../../api/controller/AtollFacilityArrivalController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const atollFacilityArrivalListState = atom({
    key: 'atollFacilityArrivalListState',
    default: [],
})
export const atollFacilityArrivalAtollState = atom({
	key: 'atollFacilityArrivalAtollState',
	default:{
		data:[],
		ovf:false,
	}
})


export const modalConfigDefault = { size: "md", wizard: false }

export const filtersDefault = []

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const atollFacilityArrivalDataStructureState = selector({
    key: 'atollFacilityArrivalDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Date',
                type: 'datepicker',
                order: { table: 1, form: 1 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 12 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Atoll',
                type: 'select',
                order: { table: 1.1, form: 1.1 }, 
                rootValue: true,
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: [{ enabled: false }], view: ['same_as:update.0'], 
                list: get(atollFacilityArrivalAtollState),
                getRequest: getAtollListRequest,
            },
			{ 
                label: 'Resort Count',
                type: 'number',
                order: { form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Resort Beds',
                type: 'number',
                order: { table: 2, form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Guest House Count',
                type: 'number',
                order: { form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Guest House Beds',
                type: 'number',
                order: { table: 3, form: 5 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Hotel Count',
                type: 'number',
                order: { form: 6 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Hotel Beds',
                type: 'number',
                order: { table: 4, form: 7 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Total Arrivals',
                type: 'number',
                order: { table: 5, form: 8 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
